export default __webpack_public_path__ + "static/media/donations_processed.eecb44c7.svg";